
// export const storeaaa =  function printA() {
export class myHelper {

  static myHelperFunction(xml, ipz) {
    // eslint-disable-next-line no-undef
    var ePosDev = new window.epson.ePOSDevice();
    var printer = null;
    console.log(ipz);
    print();
    function print() {
      var ip = ipz;
      var port = "8043";

      ePosDev.connect(ip, port, cbConnect);
      console.log("port ", port);
    }

    function cbConnect(data) {
      var deviceId = "local_printer";
      var options = {
        crypto: false,
        buffer: false
      };

      if (data == "OK" || data == "SSL_CONNECT_OK") {
        ePosDev.createDevice(
          deviceId,
          ePosDev.DEVICE_TYPE_PRINTER,
          options,
          cbCreateDevice_printer
        );
      } else {
        console.log("xxxxx ", data);
        //window.close();
      }
    }

    function cbCreateDevice_printer(devobj, retcode) {
      console.log("dddd ", retcode);
      if (retcode == "OK") {

        printer = devobj;
        printer.timeout = 60000;
        printer.onreceive = function (res) {
          console.log("pppp ", res);
          //window.close();
        };
        printer.oncoveropen = function () {
          console.log("coveropen");
          //window.close();
        };
        sendPrint();
      } else {
        console.log(retcode);
        //window.close();
      }
    }

    function sendPrint() {
      //printer.addText('Hello\n');
      //printer.addCut(printer.CUT_FEED);
      // var xml = document.getElementById("printForm:print-doc").value
      printer.setXmlString(xml);
      printer.send();
    }
  }
}
